// extracted by mini-css-extract-plugin
export default {"container":"tsx7x","header":"_2OTzZ","main":"_1WE9c","badges":"_14Ger"};